import './FeedbackTextbox.scss'

import React, { Component } from 'react'
import { Input } from 'react-bootstrap'
import cx from 'classnames'

export default class FeedbackTextbox extends Component {
  constructor(props) {
    super(props)
  }

  render() {
    const { label, value, onChange, errorMsg, placeholder, onBlur, type, manualClassName, step, disabled, iconClass, onFocus, dataTestId, maxLength } = this.props

    const className = cx(
      'form-control',
      manualClassName,
      {
        'FeedbackTextbox__incorrect-input': !!errorMsg,
        'FeedbackTextbox--with-icon': !!iconClass,
      }
    )

    const iconWrapperClass = cx(
      '',
      {'FeedbackTextbox__icon-anchor': !!iconClass}
    )

    return (
      <div className="FeedbackTextbox form-group" data-testid={ dataTestId || label }>
        <div className={iconWrapperClass}>
        { iconClass && <i className={iconClass}/>}
          <Input
            label={label}
            type={type ? type : "text"}
            value={value}
            placeholder={placeholder}
            onChange={onChange}
            onBlur={onBlur}
            className={className}
            disabled={disabled}
            step={step}
            onFocus={onFocus}
            maxLength={maxLength}
          >
          </Input>
        </div>
        <div className="FeedbackTextbox__error">
          {errorMsg ? (<span className="FeedbackTextbox__error--message">{errorMsg}</span>) : null}
        </div>
      </div>
    )
  }

}
